import Typography from '@material-ui/core/Typography'
import Icon from "storybookComponents/Icon";
import Box from '@material-ui/core/Box'
import { getDate } from "content/utils/commonParsing";
import Tooltip from "./Components/Tooltip"
import SearchBox from 'components/SearchBox'
import Selector from "./Components/selector"
import Picker from "storybookComponents/Picker"
import "./index.css"



const csvHeadersContacts = [
  { label: "Property", key: "propertyName" },
  { label: "Campaign", key: "campaignName" },
  { label: "Resident", key: "resident" },
  { label: "Referred Status", key: "referredStatus" },
  { label: "Resident’s Email", key: "residentEmail" },
  { label: "Resident’s Phone Number", key: "residentPhone" },
  { label: "Friend", key: "friend" },
  { label: "Friend’s Email", key: "friendEmail" },
  { label: "Leased ?", key: "leased" },
  { label: "Lease Date", key: "leasedDate" }
]

const csvHeadersProperties = [
  { label: "Property", key: "propertyName" },
  { label: "Campaigns", key: "title" },
  { label: "Created at", key: "createdAt" },
  { label: "Status", key: "status" },
  { label: "# Reward", key: "reward" },
  { label: "# Residents", key: "residentsCount" },
  { label: "# Friends", key: "friendsCount" },
  { label: "# Leased", key: "leasedCount" },
]


const getDataForCSV = (d) => {
  return d.map(item => {
    return {
      ...item,
      createdAt: getDate(item.createdAt),
      status: item.active ? "Active" : "Inactive",
    }
  })
}

const getPropertiesRows = (d, classes, handleClickCampaign) => {
  return d.map(item => {
    return {
      propertyName: <Typography className={`${classes.tableText} ${classes.firstColumnWeight}`}>{item.propertyName}</Typography>,
      title: <Typography className={`${classes.tableText} ${classes.campaignSelect}`} onClick={() => handleClickCampaign(item)}>
        {item.title}
      </Typography>,
      createdAt: <Typography className={classes.tableText}>
        {getDate(item.createdAt)}
      </Typography>,
      active: <Typography className={classes.tableText}>
        {item.active ? "Active" : "Inactive"}
      </Typography>,
      reward: <Typography className={classes.tableText}>
        {item.reward > 0 ? "$" + item.reward : "--"}
      </Typography>,
      residentsCount: <Typography className={classes.tableText}>
        {item.residentsCount > 0 ? item.residentsCount : "--"}
      </Typography>,
      friendsCount: <Typography className={classes.tableText}>
        {item.friendsCount > 0 ? item.friendsCount : "--"}
      </Typography>,
      leasedCount: <Typography className={classes.tableText}>
        {item.leasedCount > 0 ? item.leasedCount : "--"}
      </Typography>,
    }
  })
}


const getColumnsForProperties = (classes, handleFilterProperty, handleDateFilter, tableStatusFilter, handleFilter, statusOption) => {
  return [
    {
      field: 'propertyName', fieldName: 'Property', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true,
      filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "propertyName")}
          searchType="auto"
          placeholder="Search Property"
        />
      </Box>,
      width: 180
    },
    {
      field: 'title', fieldName: 'Campaigns', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "title")}
          searchType="auto"
          placeholder="Search Campaign"
        />
      </Box>,
      width: 300
    },
    {
      field: 'createdAt', fieldName: 'Date Created', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true,
      filterField: <div id="hyly-datePicker-property">
        <Picker
          allowPast
          type="datetime"
          icon={true}
          handleChange={handleDateFilter}
        />
      </div>,
      width: 220
    },
    {
      field: 'active', fieldName: 'Status', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true, filterField:
        <Box className={classes.boxStyles}>
          <Selector
            value={tableStatusFilter}
            classes={classes}
            onChange={handleFilter}
            options={statusOption}
          />
        </Box>
    },
    {
      field: 'reward', fieldName: '$ Reward', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "reward")}
          searchType="auto"
          placeholder="Seach Reward"
        />
      </Box>
    },
    {
      field: 'residentsCount', fieldName: <Tooltip tooltip_text="# of Residents Enrolled in the referrer campaign"><div># Residents ?</div></Tooltip>, sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "residentsCount")}
          searchType="auto"
          placeholder="Search Resident Count"
        />
      </Box>
    },
    {
      field: 'friendsCount', fieldName: <Tooltip tooltip_text="# of Referred friends who submitted a guest card or scheduled a tour"><div># Friends ?</div></Tooltip>, sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "friendsCount")}
          searchType="auto"
          placeholder="Search Friend Count"
        />
      </Box>
    },
    {
      field: 'leasedCount', fieldName: <Tooltip tooltip_text="# of Referred friends who leased"><div># Leased ?</div></Tooltip>, sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "leasedCount")}
          searchType="auto"
          placeholder="Search Leased Count"
        />
      </Box>
    },
  ]
}


const getAllCampaignsRows = (d, classes, handleClickCampaign) => {
  return d.map(item => {
    return {
      title: <Typography className={`${classes.tableText} ${classes.campaignSelect} ${classes.firstColumnWeight}`} onClick={() => handleClickCampaign(item)}>
        {item.title}
      </Typography>,
      propertyName: <Typography className={classes.tableText}>{item.propertyName}</Typography>,
    }
  })
}

const getColumnsForAllCampaigns = (classes, handleFilterProperty) => {
  return [
    {
      field: 'title', fieldName: 'Campaigns', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true, filterField: <Box className={classes.boxStylesProperty}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "title")}
          searchType="auto"
          placeholder="Search Campaign"
        />
      </Box>,
    },
    {
      field: 'propertyName', fieldName: 'Property', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell, filterable: true,
      filterField: <Box className={classes.boxStylesCampaign}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "propertyName")}
          searchType="auto"
          placeholder="Search Property"
        />
      </Box>,
      width: 200
    },

  ]
}



const getColumnsForContact = (classes, handleFilterProperty, handleDateFilter, tableStatusFilter, handleFilter, statusOption, tableReferredOption, tableReferredValue, handleReferredFilter) => {
  return [
    {
      field: 'propertyName', fieldName: 'Property', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "propertyName")}
          searchType="auto"
          placeholder="Search Property"
        />
      </Box>
    },
    {
      field: 'campaignName', fieldName: 'Campaign', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "campaignName")}
          searchType="auto"
          placeholder="Search Campaign"
        />
      </Box>
    },
    {
      field: 'resident', fieldName: 'Resident', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "resident")}
          searchType="auto"
          placeholder="Search Resident"
        />
      </Box>
    },
    {
      field: 'referredStatus', fieldName: 'Reffered Status', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <Selector
          value={tableReferredValue}
          classes={classes}
          onChange={handleReferredFilter}
          options={tableReferredOption}
        />
      </Box>
    },
    {
      field: 'residentEmail', fieldName: 'Resident’s Email', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "residentEmail")}
          searchType="auto"
          placeholder="Search Email Address"
        />

      </Box>
    },
    {
      field: 'residentPhone', fieldName: 'Resident’s Phone Number', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "residentPhone")}
          searchType="auto"
          placeholder="Search Phone Number"
        />
      </Box>
    },
    {
      field: 'friend', fieldName: 'Friend', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "friend")}
          searchType="auto"
          placeholder="Search Friend"
        />
      </Box>
    },
    {
      field: 'friendEmail', fieldName: 'Friend’s Email', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={(e) => handleFilterProperty(e, "friendEmail")}
          searchType="auto"
          placeholder="Search Email Address"
        />
      </Box>
    },
    {
      field: 'leased', fieldName: <Tooltip tooltip_text="# of Referred friends who leased"><div># Leased ?</div></Tooltip>, sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <Selector
          value={tableStatusFilter}
          classes={classes}
          onChange={handleFilter}
          options={statusOption}
        />
      </Box>
    },
    {
      field: 'leasedDate', fieldName: 'Lease Date', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee,
      filterable: true, filterField:
        <div id="hyly-datePicker-contact">
          <Picker
            allowPast
            type="date"
            icon={true}
            handleChange={handleDateFilter}
          />
        </div>
    },
  ]
}

const handleClick = (url) => {
  window.open(url)
}

const getContactRows = (d, classes, handleClickCampaign, contact) => {
  return d.map(item => {
    return {
      propertyName: <Typography className={`${classes.tableText} ${classes.firstColumnWeight}`}>{item.propertyName}</Typography>,
      campaignName: <Typography className={`${classes.tableText} ${classes.campaignSelect}`} onClick={() => handleClickCampaign(item)}>
        {item.campaignName}
      </Typography>,
      resident: <Typography className={`${classes.tableText} ${!contact && classes.firstColumnWeight}`}>{item.resident ? item.resident : "--"}</Typography>,
      referredStatus: <Typography className={classes.tableText}>{item.referredStatus ? "Referred" : "Not Referred"}</Typography>,
      residentEmail: <Typography className={`${classes.tableText} ${item.residentEmail && classes.emailLink}`} onClick={item.residentEmail ? () => handleClick(item.residentCrmUrl) : () => { }}>
        {item.residentEmail ? item.residentEmail : "--"}
      </Typography>,
      residentPhone: <Typography className={classes.tableText}>
        {item.residentPhone ? item.residentPhone : "--"}
      </Typography>,
      friend: <Typography className={classes.tableText}>
        {item.friend ? item.friend : "--"}
      </Typography>,
      friendEmail: <Typography className={`${classes.tableText} ${item.friendEmail && classes.emailLink}`} onClick={item.friendEmail ? () => handleClick(item.friendCrmUrl) : () => { }}>
        {item.friendEmail ? item.friendEmail : "--"}
      </Typography>,
      leased: <Typography className={classes.tableText} style={{
        color: item.leased ? "#00C113" : item.leased === false ? "#E75F75" : "#333333"
      }}>
        {item.leased ? "Yes" : item.leased === false ? "No" : "--"}
      </Typography>,
      leasedDate: <Typography className={classes.tableText}>
        {item.leasedDate ? item.leasedDate : "--"}
      </Typography>,

    }
  })
}


const getData = (d) => {
  return d.map(item => {
    return {
      propertyName: item.propertyName,
      campaignName: item.campaignName,
      resident: item.resident,
      referredStatus: item.referredStatus ? "Referred" : "Not Referred",
      residentEmail: item.residentEmail,
      residentPhone: item.residentPhone,
      friend: item.friend,
      friendEmail: item.friendEmail,
      friendPhone: item.friendPhone,
      leased: item.leased ? "Yes" : "No",
      leasedDate: item.leasedDate,
    }
  })
}


export {
  csvHeadersContacts,
  getContactRows,
  getColumnsForContact,
  getData,
  csvHeadersProperties,
  getPropertiesRows,
  getColumnsForProperties,
  getDataForCSV,
  getAllCampaignsRows,
  getColumnsForAllCampaigns
}